
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

interface Insight {
  type: string;
  title: string;
  description: string;
  action: string;
}

interface InsightsSectionProps {
  insights: Insight[];
}

export const InsightsSection = ({ insights }: InsightsSectionProps) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Insights & Recommendations</h3>
      <div className="space-y-3">
        {insights.map((insight, index) => (
          <div key={index} className="flex items-center justify-between p-3 rounded-lg border">
            <div className="flex-1">
              <h4 className="font-medium">{insight.title}</h4>
              <p className="text-sm text-muted-foreground">{insight.description}</p>
            </div>
            <Button variant="outline" size="sm">
              {insight.action}
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
};
